<template>
  <footer class="footer px-4 mx-2">
    <cookie-law>
      <div slot-scope="props" class="d-flex ml-auto mr-auto">
        <p >
            Our site serves cookies to analyze traffic, provide security, and enable purchases. By continuing to use our site
            you are providing consent. <a href="https://www.imagineproducts.com/about/privacy-notice" target="_blank">More
            info</a>.
        </p>
        <span class="ml-2"><b-button @click="props.accept" size="sm" v-b-popover.hover.left="'Accept Cookies'" variant="outline-primary">Accept</b-button></span>
      </div>
    </cookie-law>
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}}
          <a
            href="https://www.imagineproducts.com"
            class="font-weight-bold ml-1"
            target="_blank"
          >Imagine Products, Inc.</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a
              href="https://www.imagineproducts.com"
              class="nav-link"
              target="_blank"
            >Imagine Products</a>
          </li>
          <li class="nav-item">
            <a
              href="https://www.imagineproducts.com/about"
              class="nav-link"
              target="_blank"
            >About Us</a>
          </li>
          <li class="nav-item">
            <a
              href="https://www.imagineproducts.com/about/conditions-of-use"
              class="nav-link"
              target="_blank"
            >Conditions of Use</a>
          </li>
          <li class="nav-item">
            <a
              href="https://www.imagineproducts.com/about/privacy-notice"
              class="nav-link"
              target="_blank"
            >Privacy Notice</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: { CookieLaw },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
.Cookie--mytheme .Cookie__button {
  border: 0;
  border-radius: 0.25rem;
  background: #1E88E5;
  color: white;
  font-family: system-ui, sans-serif;
  font-size: 1rem;
  line-height: 1.2;
  white-space: nowrap;
  text-decoration: none;
  padding: 0.25rem 0.5rem;
  margin: 0.25rem;
  cursor: pointer;
}
</style>
